import { message, Popover, Radio, Spin, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { GoPasskeyFill } from 'react-icons/go';
import { useMainContext } from '../../hooks/useMainContext';
import { LoadingOutlined } from '@ant-design/icons';

const PopoverContent = observer(({ setIsOpen }) => {
    const { viewManager, apiManager } = useMainContext();
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleTransferOwnership = async () => {
        if (loading) return;
        if (!selectedUser) {
            message.error('Please select a user');
            return;
        }
        const url = new URL(window.location.href);
        const projectId = url.searchParams.get('project_id');
        if (!projectId) {
            message.error('Please select a project');
            return;
        }
        setLoading(true);
        try {
            const response = await apiManager.transferProjectOwnership(
                projectId,
                selectedUser,
            );
            const result = await response.json();
            if (!response.ok)
                throw new Error(result.error || 'Failed to transfer ownership');
            message.success(result.message);
            setTimeout(() => {
                url.searchParams.delete('project_id');
                window.history.replaceState({}, '', url);
                window.location.reload();
            }, 1000);
            setIsOpen(false);
        } catch (error) {
            console.error('Error transferring ownership:', error);
            message.error(
                error.message ||
                    'Error transferring ownership of project. Please try again.',
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="">
            <h1 className="text-black text-[14px] font-medium font-favorit px-3 pt-3">
                Users List
            </h1>
            <div className="px-3 pt-1">
                <Radio.Group
                    className="overflow-y-auto max-h-[300px] flex flex-col gap-1 font-favorit text-[14px] font-medium leading-[16px] text-[#5B5F5D] "
                    onChange={(e) => {
                        setSelectedUser(e.target.value);
                    }}
                    value={selectedUser}>
                    {viewManager.usersList?.map((user, index) => (
                        <Radio
                            value={user.id}
                            key={index}
                            className="text-[#5B5F5D]">
                            {user?.email}
                        </Radio>
                    ))}
                </Radio.Group>
            </div>
            <div className="flex  px-3 pb-3 gap-2 mt-3">
                <button
                    onClick={() => {
                        setIsOpen(false);
                        setSelectedUser(null);
                    }}
                    className={
                        'h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white transition-all duration-300 ease-in-out }'
                    }>
                    Cancel
                </button>
                <button
                    onClick={() => {
                        handleTransferOwnership();
                    }}
                    className={
                        'h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal bg-theme-orange text-[#fff] hover:bg-theme-orange-hover hover:text-white transition-all duration-300 ease-in-out }'
                    }>
                    {loading ? (
                        <Spin
                            indicator={<LoadingOutlined spin />}
                            className="text-white"
                        />
                    ) : (
                        'Transfer'
                    )}
                </button>
            </div>
        </div>
    );
});

const TransferOwnership = observer(({ disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const getButtonStyles = (isActive) => ({
        backgroundColor: disabled
            ? '#f5f5f5'
            : isActive
              ? '#F46147'
              : '#f5f5f5',
        color: disabled ? '#999' : isActive ? '#fff' : '#000',
        transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
        cursor: disabled ? 'not-allowed' : 'pointer',
    });

    return (
        <Tooltip
            title={<span className="text-black">Transfer Ownership</span>}
            placement="bottom"
            color="white">
            <Popover
                content={<PopoverContent setIsOpen={setIsOpen} />}
                trigger="click"
                placement="bottom"
                open={isOpen}
                disabled={disabled}
                styles={{
                    body: {
                        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
                        border: '1px solid #B6B6B6',
                        padding: '0px',
                        fontSize: '14px',
                        fontWeight: '400',
                        backgroundColor: '#E7E7E7 !important',
                        minWidth: '220px',
                        maxWidth: '310px',
                        width: 'fit-content !important',
                        marginTop: '0px',
                        borderRadius: '8px',
                        overflow: 'hidden',
                    },
                }}
                onOpenChange={(visible) => !disabled && setIsOpen(visible)}>
                <button
                    disabled={disabled}
                    style={getButtonStyles(isOpen)}
                    className="flex justify-center items-center h-12 w-12 rounded-full"
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                    onMouseEnter={(e) => {
                        if (!disabled) {
                            e.currentTarget.style.backgroundColor = '#ccc';
                        }
                    }}
                    onMouseLeave={(e) => {
                        Object.assign(
                            e.currentTarget.style,
                            getButtonStyles(isOpen),
                        );
                    }}>
                    <GoPasskeyFill className="text-xl" />
                </button>
            </Popover>
        </Tooltip>
    );
});

export default TransferOwnership;
